import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import Image from "next/image";
import Link from "next/link";

type SmallProps = {
  article: Content.Article;
};

const Small = (props: SmallProps) => {
  const author = props.article.fields.authors?.[0];
  const title = props.article.fields.teaserTitle || props.article.fields.title;
  const hideBylineImage = props.article.fields.hideBylineImage;

  return (
    <Link
      href={`/${props.article.fields.slug}`}
      className="bg-sand-700  group flex flex-col items-center p-4 text-gray-500 "
    >
      <Image
        src="/images/quote.svg"
        alt="&ldquo;"
        width={45}
        height={39}
        className="-mb-4"
        unoptimized
      />

      {title && (
        <TeaserHeading
          text={title}
          className="text-2xl text-center !font-semibold"
        />
      )}

      {author?.fields.name && (
        <div className="font-brush text-xl">{author.fields.name}</div>
      )}
    </Link>
  );
};

export default Small;
